<template>
    <div class="full-height">
      <billing-order-jt-data-table-buttons
        @action-button="actionButtonHandler"
        @show-message="showMessageHandler"
        @action-change="onActionChange"
      />
      <component
        :is="dataTableComponent"
        v-show="hasData"
        ref="tableRef"
        :has-data.sync="hasData"
        :virtual-scroll="virtualScroll"
        :rows-per-page-options="rowsPerPageOptions"
        v-bind="computedProps"
      >
      <template v-if="!hasScopedSlots" v-slot:header="props">
          <slot name="header" :props="{ ...props }">
            <jt-data-table-header
              :props="props"
              @select-all="onSelectAllChangeHandler"
            />
          </slot>
        </template>
        <template v-if="!hasScopedSlots" v-slot:body="props">
          <slot name="body" :props="{ ...props }">
            <jt-data-table-row
              :props="props"
              v-bind="$props"
              @click-row="onClickRowHandler"
              @action-button="onActionButtonHandler"
              @toggle-change="(data) => $emit('toggle-change', data)"
            />
            <jt-data-table-hidden-row :props="props" />
          </slot>
        </template>

        <template v-for="(value, key) in $scopedSlots" v-slot:[key]="props">
          <slot :name="key" :props="props.props" v-bind="{ props: 'props' }">
          </slot>
        </template>
      </component>
      <jt-empty-message
        v-show="!hasData"
        :message="messageDataEmpty || $gettext('NO_DATA_AVAILABLE')"
        size="10em"
      />
    </div>
  </template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtDataTable } from 'jtech-webcomps'
import BillingOrderJtDataTableButtons from './BillingOrderJtDataTableButtons.vue'

  @Component({
    components: {
      JtDataTable, BillingOrderJtDataTableButtons
    },
    mixins: [JtDataTable],
    props: {
      columnEdit: {
        type: Function
      },
      bottomEdit: {
        type: Function
      },
      rowSet: {
        type: Function
      },
      selectionForce: {
        type: Boolean,
        default: false
      },
      singleselect: {
        type: Boolean
      },
      multiselect: {
        type: Boolean
      },
      buttons: {
        required: false,
        type: Array,
        default: () => []
      },
      rowButtons: {
        required: false,
        type: Boolean,
        default: false
      },
      buttonsFilter: {
        type: Function
      },
      noneselect: {
        type: Boolean
      },
      fields: {
        type: Array,
        required: true,
        default: () => []
      },
      extraParams: {
        type: Object,
        default: () => {
          return {}
        }
      },
      defaultHttpOptions: Object,
      nmInterface: String,
      rowKey: {
        type: String,
        default: 'id'
      },
      title: String,
      isPaginated: {
        type: Boolean,
        default: true
      },
      forms: { type: Array },
      apiMode: {
        type: Boolean,
        default: true
      },
      data: {
        type: Array,
        default: () => []
      },
      messageDataEmpty: {
        type: String,
        default: ''
      },
      rowsPerPageOptions: {
        type: Array,
        default: () => [3, 5, 7, 10, 15, 20, 25, 50, 0]
      },
      virtualScroll: Boolean,
      imageColumnNotFound: String
    }
  })
class BillingOrderJtDataTable extends Vue {
    onActionChange (button) {
      this.$emit('action-change', button)
    }

    mounted () {
      this.removePaginationFromBillingTypeColumn()
    }

    updated () {
      this.removePaginationFromBillingTypeColumn()
    }

    removePaginationFromBillingTypeColumn () {
      const billingTypeColumn = this.computedProps.fields.find(e => e.name == 'billingType')
      billingTypeColumn.sortable = false
    }
  }
export default BillingOrderJtDataTable
</script>
  <style lang="stylus" scoped>
  @import '~quasar-variables';

  .jt-datatable {
    .hidden-row {
      label {
        font-weight: bold;

        &:after {
          content: '  ';
        }
      }

      div {
        text-align: left;
        padding: 0px 10px;
      }
    }

    th, td {
      text-align: center;
    }

    thead tr th {
      position: sticky !important;
      top: 0;
      z-index: 2;
    }

    .q-table__bottom, thead tr {
      background-color: #eceff1;
      box-shadow: 0 1px 0 0 #ddd, 0 -5px 0 0 #fff;
    }

    .q-table thead tr {
      height: 40px;
      text-transform: uppercase;
      color: $grey-7;
      font-weight: 500;
      position: sticky !important;
      top: 0;
      z-index: 2;
    }
  }
  </style>
